/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow': {
    width: 41,
    height: 40,
    viewBox: '0 0 41 40',
    data: '<path pid="0" d="M2.827 28L20.07 11.636 37.313 28" _stroke="#000" stroke-width="4" stroke-linecap="square"/>'
  }
})
